import { ActionTypes } from "@/App/constants/actionTypes";
import { ProductListTypes } from "@/types";

type GetProductList = {
  type: typeof ActionTypes.GET_PRODUCT_LIST;
  payload: ProductListTypes.ProductListSearchOptions;
};

export const getProductList = (data: ProductListTypes.ProductListSearchOptions): GetProductList => {
  return {
    type: ActionTypes.GET_PRODUCT_LIST,
    payload: data,
  };
};

type GetProductListResults = {
  type: typeof ActionTypes.GET_PRODUCT_LIST_RESULTS;
  payload: ProductListTypes.ProductListSearchResponse;
};

export const getProductListResults = (data: ProductListTypes.ProductListSearchResponse): GetProductListResults => {
  return {
    type: ActionTypes.GET_PRODUCT_LIST_RESULTS,
    payload: data,
  };
};

export type ProductListGetActions = GetProductList | GetProductListResults;
